import React, { Fragment, useEffect, useRef, useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import {listAssets, uploadAsset, deleteAsset} from '../../redux/actions/assets';

import {bindEvent} from '../../utils/event.utils';
import { connect } from 'react-redux';

import {first, get, isEmpty, map, find } from 'lodash-es'
import { isStatusInit } from '../../redux/reducers/status';
import { IconButton, List, ListItem, Button, Link } from '@material-ui/core';

import IconUpload from '@material-ui/icons/CloudUpload';
import IconDownload from '@material-ui/icons/CloudDownload';
import IconDelete from '@material-ui/icons/Delete';

import styles from './TeamProjectScene.module.css';
import { Redirect, Route, Switch, useHistory, useLocation } from 'react-router-dom';

import {ROUTE_TEAM_PROJECT_SCENE,ROUTE_TEAM_PROJECT_SCENE_VIEWER} from '../../config/routes';
import { createRoutePath } from '../../utils/routes.utils';

const TeamProjectScene = ({
  teamId,
  projectId,
  sceneId,
  assets,
  assetsInit,
  listAssets,
  deleteAsset,
  uploadAsset
}) => {
  const history = useHistory();
  const location = useLocation();
  const [selectedAsset,setSelectedAsset] = useState();
  const [ready,setReady] = useState(false);
  const [initAR,setInitAR] = useState(false);
  const [showMenu,setShowMenu] = useState(false);
  const previewRef = useRef(null);
  const uploadRef = useRef(null);

  const dirProject = `/teams/${teamId}/projects/${projectId}`;

  const toggleMenu = () => {
    setShowMenu( !showMenu );
  }

  const setCurrentAsset = useCallback( ( asset ) => {
    if( asset ){
      //send a message to the page to tell it which asset we're using
      tellSceneWindow('setModelFile',asset.downloadURL);
      setSelectedAsset( asset );
    }
  }, [] );

  const tellSceneWindow = ( action, data ) => {
    // previewRef.emit
    try{
      const contentWindow = get( previewRef, 'current.contentWindow' );
      if( contentWindow ){
        contentWindow.postMessage( JSON.stringify({action,data}), '*' );
      }
    }catch( err ){
      //console.error( err );
    }
  }

  const AssetListItem = ({data}) => {
    const open3D = () => {
      // setSelectedAsset( data );
      history.push( `${location.pathname}/v/3d?model=${data.name}` );
    }
    const openAR = () => {
      // setSelectedAsset( data );
      history.push( `${location.pathname}/v/ar?model=${data.name}` );
    }

    const deleteItem = () => {
      if( window.confirm(`Are you sure you want to delete '${get( data, 'name' )}'`) ){
        deleteAsset( data );
      }
    }
    console.log( data.downloadURL );
    return <ListItem className={styles.item}>
      <Link download href={data.downloadURL}><IconButton><IconDownload /></IconButton></Link>
      <span className={styles.spacer}>{data.name}</span> 
      <Button variant="contained" onClick={open3D}>3D</Button>
      <Button variant="contained" onClick={openAR}>AR</Button>
      <IconButton variant="contained" onClick={deleteItem}><IconDelete /></IconButton>
    </ListItem>
  }

  const fileUploadAction = () => uploadRef.current.click();

  const fileUploadInputChange = ( e ) => {
    //upload this file - then clear the ref
    var files = e.target.files;
    if( !isEmpty( files ) ){
      uploadAsset( dirProject, first( files ) );
      //upload this file
      uploadRef.current.value = null;
    }
  }

  const resetSelectedAsset = ( asset ) => {
    // console.log('resetSelectedAsset', asset, selectedAsset );
    if( asset !== selectedAsset ){
      setTimeout(() => {
        // alert(`setSelectedAsset: ${get(asset,'name')}`);
        setSelectedAsset( asset );

        if( !asset ){
          setInitAR( false );
          setReady( false );
        }
      }, 10);
    }
  }

  useEffect(() => {
    if( !assetsInit ){
      listAssets( dirProject );
    }

    //add listener for the window message
    bindEvent( window, 'message', ( e ) => {
      var message = null;
      try{
        message = JSON.parse( e.data );
      }catch( err ){
        //dont continue - something else is messaging
        return;
      }
      // console.log('bindEvent:message',message);
      try{
        // alert(`action: ${message.action}`);
        switch( message.action ){
          case 'ready':
            setReady( true );
          break;
          default:
            console.warn(`Unknown action '${message.action}' received`)
          break;
        }
      }catch( err ){
        // console.error( err );
      }
    } );
    return () => {
      //remove listener for the window message
    }
  }, [assetsInit,listAssets]);

  // useEffect(() => {
  //   if( !isEmpty( assets ) && !selectedAsset ){
  //     setCurrentAsset( first( assets ) );
  //   }
  // }, [assets,selectedAsset,setCurrentAsset]);

  useEffect(() => {
    if( ready ){
      //we can send a message to the preview to tell it which model we want to display
      setCurrentAsset( selectedAsset );
    }
  }, [ready,setCurrentAsset,selectedAsset]);
  
  const initialiseAR = () => {
    setTimeout( () => {
      const contentWindow = get( previewRef, 'current.contentWindow' );
      if( !initAR && contentWindow ){
        //we can send a message to the preview to tell it which model we want to display
        window.XRIFrame.registerXRIFrame('preview-iframe');
        // alert('initAR');
        setTimeout(() => {
          setInitAR( true );
        }, 10 )
      }
    }, 100 )
  }

  return <div className={styles.TeamProjectScene}>
    <Switch>
      <Route exact path={ROUTE_TEAM_PROJECT_SCENE} render={()=>{
        resetSelectedAsset( null );
        return <Fragment>
          <div className={styles.upload}>
            <input type="file" hidden ref={uploadRef} onChange={fileUploadInputChange} />
            <IconButton onClick={fileUploadAction}><IconUpload /></IconButton>
          </div>
          <List className={styles.list}>
            {map( assets, (asset, index) => {
              return <AssetListItem key={index} data={asset} />
            } )}
            {isEmpty( assets ) && <p style={{textAlign:'center'}}>(no models uploaded)</p>}
          </List>
        </Fragment>
      }} />
      <Route exact path={ROUTE_TEAM_PROJECT_SCENE_VIEWER} render={(route)=>{
        const search = new URLSearchParams( get( route, 'location.search' ) );
        const viewer = get( route, 'match.params.viewerId' );
        const iSelectedAsset = find( assets, {name:search.get('model')} );

        if( selectedAsset !== iSelectedAsset ){
          resetSelectedAsset( iSelectedAsset );
        }

        if( selectedAsset ){
          switch( viewer ){
            case '3d':
              return <iframe 
              ref={previewRef} 
              id="preview-iframe"
              title="AR Scene"
              allow="camera;microphone;gyroscope;accelerometer;"
              src={`https://gltfviewer.feedar.dev?model=${escape(selectedAsset.downloadURL)}`} />;
            break;
            case 'ar':
              //this needs initialising
              initialiseAR();
              return <iframe 
                ref={previewRef} 
                id="preview-iframe"
                title="AR Scene"
                allow="camera;microphone;gyroscope;accelerometer;"
                src="https://meyouandus.8thwall.app/feedar-scene-manager" />;
            break;
          }
        }
      }} />
      <Route render={( route ) => {
        return <Redirect to={createRoutePath(ROUTE_TEAM_PROJECT_SCENE,route.match.params)} />
      }}/>
    </Switch>
  </div>
}

TeamProjectScene.propTypes = {
  teamId : PropTypes.string.isRequired,
  projectId : PropTypes.string.isRequired,
  sceneId : PropTypes.string.isRequired,
};

TeamProjectScene.defaultProps = {};

const mapStateToProps = state => ({
  assets: get( state, 'assets.items' ),
  assetsInit: isStatusInit( get( state, 'assets.status' ) ),
});

export default connect(mapStateToProps, { 
  listAssets,
  uploadAsset,
  deleteAsset
})(TeamProjectScene);
